import {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {Menu, MenuItem, MenuButton, SubMenu} from '@szhsin/react-menu'
import {useTheme} from 'common/themes/ThemeHelpers'
import {BulkAction} from '../types'
// todo: remove after testing for react-menu, also remove the files
// import BulkActionButton from './Button'
// import BulkActionMenu from './Menu'

const BulkActions: FC<{actions: BulkAction[]; selectedRows: any[]; className?: string}> = ({
  actions,
  selectedRows,
  className,
}) => {
  const intl = useIntl()
  const theme = useTheme()
  return (
    <div className={clsx(className)}>
      <Menu
        theming={theme}
        menuButton={
          <MenuButton className='btn btn-sm btn-light-warning'>
            {intl.$t({id: 'GENERAL.BULK_ACTIONS'})}
            <span className='svg-icon fs-3 rotate-180 ms-3 me-0'>
              <i className='fa fa-angle-down'></i>
            </span>
          </MenuButton>
        }
        transition
      >
        {actions.map((action, idx) => {
          if (action.type === 'button') {
            return (
              <MenuItem
                className={action.className}
                onClick={() => action.onClick(selectedRows)}
                key={idx}
              >
                {action.label}
              </MenuItem>
            )
          } else if (action.type === 'menu') {
            return (
              <SubMenu className={action.className} label={action.label} key={idx}>
                {action.actions.map((subAction, subIdx) => (
                  <MenuItem
                    className={subAction.className}
                    onClick={() => subAction.onClick(selectedRows)}
                    key={subIdx}
                  >
                    {subAction.label}
                  </MenuItem>
                ))}
              </SubMenu>
            )
          }
          return null
        })}
      </Menu>

      {/* <button
        type='button'
        className='btn btn-sm btn-light-warning'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
        // data-kt-menu-offset='30px, 30px'
      >
        {intl.$t({id: 'GENERAL.BULK_ACTIONS'})}
        <span className='svg-icon fs-3 rotate-180 ms-3 me-0'>
          <i className='fa fa-angle-down'></i>
        </span>
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px'
        data-kt-menu='true'
      >
        {actions.map((action, idx) => {
          const className = clsx(
            {
              'mt-2': idx === 0,
              'mb-2': idx === actions.length - 1,
            },
            action.className
          )
          if (action.type === 'button') {
            return (
              <BulkActionButton
                action={{className, ...action}}
                selectedRows={selectedRows}
                key={idx}
              />
            )
          } else if (action.type === 'menu') {
            return (
              <BulkActionMenu
                action={{className, ...action}}
                selectedRows={selectedRows}
                key={idx}
              />
            )
          }
          return null
        })}
      </div> */}
    </div>
  )
}

export default BulkActions
